<ngx-loading-bar color="#673ab7" height="3px" diameter="18px"></ngx-loading-bar>
<router-outlet></router-outlet>
